import { BadgeCheck, Heart, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const values = [
  { icon: ShieldCheck, label: "Reliable" },
  { icon: BadgeCheck, label: "Thorough" },
  { icon: Heart, label: "Trusted" },
];

export default function About() {
  return (
    <section id="about" className="py-28 md:py-36 bg-white" data-testid="about-section">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-16 items-center">
        <div className="md:col-span-8 md:col-start-3 text-center">
          <Reveal>
            <p className="text-base md:text-lg font-light leading-relaxed text-pine/70 max-w-lg mx-auto">
              Sparkling Ambitions Cleaning Co. is a Knoxville-born cleaning business, built on one
              simple belief: a clean home or business is a happy one. From weekly residential cleans
              to hotel-crisp Airbnb turnovers, every space is treated like our own — and we don't
              leave until it sparkles.
            </p>
            <p className="mt-5 font-editorial italic text-xl text-seateal" data-testid="about-motto">
              “Let us do the dirty work for you.”
            </p>
          </Reveal>
          <Reveal delay={0.22}>
            <div className="mt-10 flex flex-wrap justify-center gap-3">
              {values.map((v) => (
                <span
                  key={v.label}
                  className="inline-flex items-center gap-2 rounded-full border border-foam/60 bg-foam/10 px-5 py-2.5 text-sm font-normal text-pine"
                  data-testid={`about-value-${v.label.toLowerCase()}`}
                >
                  <v.icon size={15} strokeWidth={1.75} className="text-seateal" />
                  {v.label}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
